import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FeatureGates, {
	FeatureGateEnvironment,
	PerimeterType,
} from '@atlaskit/feature-gate-js-client';
import { FeatureGatesInitialization } from '@atlassian/feature-gates-react';
import { getAppConfig } from '../store';
import { EnvironmentType } from './index';

export const FEATURE_GATES = {
	SPACE_PERMISSION_CHECK: 'confluence-cq-fe_space-permission-check',
	SEND_MEDIA_CONTENT_ID: 'confluence-cq-fe_send-media-content-id',
	SHOW_TOPIC_LOGO_UPLOAD: 'confluence-cq-fe_show-topic-logo-upload',
};

export const checkGate = (gateName: string): boolean => FeatureGates.checkGate(gateName);

const MAP_FEATURE_GATE_ENVIRONMENTS = {
	[EnvironmentType.PROD]: FeatureGateEnvironment.Production,
	[EnvironmentType.FEDRAMP_MODERATE_PROD]: FeatureGateEnvironment.Production,
	[EnvironmentType.STAGING]: FeatureGateEnvironment.Staging,
	[EnvironmentType.FEDRAMP_MODERATE_STAGING]: FeatureGateEnvironment.Staging,
	[EnvironmentType.LOCAL]: FeatureGateEnvironment.Development,
	[EnvironmentType.DEV]: FeatureGateEnvironment.Development,
	[EnvironmentType.NEBULAE]: FeatureGateEnvironment.Staging,
	[EnvironmentType.UNKNOWN]: FeatureGateEnvironment.Staging,
};

const FFS_API_KEYS = {
	[FeatureGateEnvironment.Production]: {
		[PerimeterType.FEDRAMP_MODERATE]: '7a4a32a0-6fde-41d9-89cc-513842ae0d9f',
		[PerimeterType.COMMERCIAL]: '1884085a-327f-4d27-b1d8-880ef38fc93a',
	},
	[FeatureGateEnvironment.Staging]: {
		[PerimeterType.FEDRAMP_MODERATE]: '262d9ca6-6ff4-4e20-af99-8abe64405fc0',
		[PerimeterType.COMMERCIAL]: '8081bc31-b9a6-46b4-9c8e-1e5df384b3ac',
	},
	[FeatureGateEnvironment.Development]: {
		[PerimeterType.COMMERCIAL]: 'd54e8ba4-ae16-4403-8936-e30115fff298',
	},
};

const getStatsigAPIKey = (environment: FeatureGateEnvironment, perimeter: PerimeterType) => {
	const apiKey = FFS_API_KEYS[environment]?.[perimeter];

	if (!apiKey) {
		console.error(
			`feature-flag-service API key for ${perimeter} ${environment} has not been defined.`,
		);
	}
	return apiKey;
};

export class FeatureFlagsProvider extends PureComponent {
	static propTypes = {
		accountId: PropTypes.string.isRequired,
		children: PropTypes.node.isRequired,
	};

	render() {
		const { accountId, children } = this.props;
		const { microsEnvType, microsPerimeter, tenantId } = getAppConfig();
		const env = MAP_FEATURE_GATE_ENVIRONMENTS[microsEnvType];

		return (
			<FeatureGatesInitialization
				enabled
				options={{
					targetApp: 'confluence-questions-connect_web',
					environment: env,
					apiKey: getStatsigAPIKey(env, microsPerimeter),
					perimeter: microsPerimeter,
				}}
				identifiers={{
					atlassianAccountId: accountId,
					tenantId,
				}}
			>
				{children}
			</FeatureGatesInitialization>
		);
	}
}
